module.exports = __webpack_public_path__ + "static/media/wb.6ba96a1b.png";